import type { StateCreator } from "zustand";
import type { UploadPicturePayloadType } from "@/repositories/photographic-records/types";

export interface PendingPicture extends UploadPicturePayloadType {
  timestamp: number;
  retryCount: number;
}

export interface PendingPicturesSliceState {
  pendingPictures: PendingPicture[];
  addPendingPicture: (payload: UploadPicturePayloadType) => void;
  removePendingPicture: (timestamp: number) => void;
  updatePendingPicture: (timestamp: number, updates: Partial<PendingPicture>) => void;
  clearPendingPictures: () => void;
}

export const createPendingPicturesSlice: StateCreator<
  PendingPicturesSliceState,
  [],
  [],
  PendingPicturesSliceState
> = (set, _get) => ({
  pendingPictures: [],
  addPendingPicture: (payload) => {
    const newPendingPicture: PendingPicture = {
      ...payload,
      timestamp: Date.now(),
      retryCount: 0,
    };
    set((state) => ({
      pendingPictures: [...state.pendingPictures, newPendingPicture],
    }));
  },
  removePendingPicture: (timestamp) =>
    set((state) => ({
      pendingPictures: state.pendingPictures.filter((picture) => picture.timestamp !== timestamp),
    })),
  updatePendingPicture: (timestamp, updates) =>
    set((state) => ({
      pendingPictures: state.pendingPictures.map((picture) => {
        if (picture.timestamp === timestamp) {
          return { ...picture, ...updates };
        }
        return picture;
      }),
    })),
  clearPendingPictures: () => set({ pendingPictures: [] }),
});
